import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
    fetchPortfolioDetailsAction,
    removePortfolioAction
} from "../../../../utils/redux/portfolio/portfolioActions";

const PortfolioDetails = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { selectedPortfolio } = useSelector(
        state => state.portfolio
    );

    /* ================= FETCH DETAILS ================= */

    useEffect(() => {
        dispatch(fetchPortfolioDetailsAction(id));
    }, [dispatch, id]);

    /* ================= DELETE ================= */

    const handleDelete = async () => {
        if (!window.confirm("Are you sure you want to delete this project?")) return;

        const res = await dispatch(removePortfolioAction(id));

        if (res?.success) {
            toast.success("Portfolio deleted successfully");
            navigate("/portfolio");
        } else {
            toast.error("Delete failed");
        }
    };

    if (!selectedPortfolio) {
        return (
            <div className="container py-5 text-center">
                <h5>Loading project details...</h5>
            </div>
        );
    }

    const {
        name,
        type,
        description,
        location,
        images = []
    } = selectedPortfolio;

    const thumbnail = images.find(img => img.isThumb);

    return (
        <div className="container py-4">
            <div className="card">
                <div className="card-body">

                    {/* HEADER */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                            <h3 className="mb-1">
                                {type === "HOME" ? "Home Portfolio" : name}
                            </h3>
                            <span className="badge bg-secondary">
                                {type}
                            </span>
                        </div>

                        <div>
                            <button
                                className="btn btn-outline-primary me-2"
                                onClick={() => navigate(`/portfolio/edit/${id}`)}
                            >
                                Edit
                            </button>
                            <button
                                className="btn btn-outline-danger"
                                onClick={handleDelete}
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                    {/* BASIC INFO */}
                    {type === "HOSPITALITY" && (
                        <div className="mb-4">
                            <p><strong>Location:</strong> {location}</p>
                            <p><strong>Description:</strong> {description}</p>
                        </div>
                    )}

                    {/* IMAGE GALLERY */}
                    <div>
                        <h5 className="mb-3">Project Images</h5>

                        {images.length ? (
                            <div className="row">
                                {images.map((img, index) => (
                                    <div className="col-md-3 mb-3" key={index}>
                                        <div className="card">
                                            <img
                                                src={img.url}
                                                alt={`Project ${index}`}
                                                className="card-img-top"
                                                style={{
                                                    height: "200px",
                                                    objectFit: "cover"
                                                }}
                                            />
                                            {img.isThumb && (
                                                <div className="badge bg-primary position-absolute m-2">
                                                    Thumbnail
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="text-muted">
                                No images available
                            </p>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PortfolioDetails;
